import { useDispatch, useSelector } from 'react-redux';
import styles from './styles.module.scss';
import { getUserRoleSelector } from 'store/selectors/user';

import { AGENT, TEAM_ADMIN, TEAM_BASIC, TEAM_OWNER, THIRD_PARTY } from 'settings/constants/roles';
import {
  getAgentTeamIsActiveSelector,
  getAgentTeamRoleSelector,
} from 'store/selectors/agentTeamDetail';
import classNames from 'classnames';
import { Icons } from 'pages/Workshop/Icons';
import { Filter } from '../../../Transactions/TransactionTasks/components/Tasks/components/Actions/Filter';
import { TasksFilter } from '../../TasksFilter';
import { useState } from 'react';
import { resetTransactionEffect } from 'store/effects';
import { TaskModal } from 'pages/Workshop/Transactions/TransactionTasks/components/TaskModal';
import { MultiSelect } from 'components/Icons';

export const TaskActionButtons = (props) => {
  const userRole = useSelector(getUserRoleSelector);

  const isTeamAgentActive = useSelector(getAgentTeamIsActiveSelector);
  const agentRole = useSelector(getAgentTeamRoleSelector);
  const dispatch = useDispatch();

  const [taskModal, setTaskModal] = useState(false);

  const isAgentOrThirdParty = userRole === AGENT || userRole === THIRD_PARTY;

  const { onSearchClick, showSelection, onShowSelection } = props;
  const onNewTaskClick = () => {
    dispatch(resetTransactionEffect());
    setTaskModal(true);
  };

  const renderNewButton = () => {
    return (
      <div className={classNames(styles.btn, styles.newBtn)} onClick={onNewTaskClick}>
        <Icons className={styles.addIcon} variant={Icons.ADD} />
        <span className={styles.iconText}>New</span>
      </div>
    );
  };

  const renderTeamFilters = () => {
    if (
      userRole === THIRD_PARTY ||
      (isTeamAgentActive && [TEAM_OWNER, TEAM_ADMIN, TEAM_BASIC].includes(agentRole))
    ) {
      return <TasksFilter />;
    }
  };

  return (
    <div className={styles.actionButtonsPanel}>
      {isAgentOrThirdParty ? (
        <>
          {renderNewButton()}

          <TaskModal
            isOpen={taskModal}
            onCloseModal={() => setTaskModal(false)}
            isNew={true}
            isAggregatedTasks
          />
        </>
      ) : (
        <></>
      )}

      {renderTeamFilters()}

      <div className={classNames(styles.btn)} onClick={onSearchClick}>
        <Icons className={styles.btnIcon} variant={Icons.SEARCH} color="#515151" />
      </div>

      <Filter isAggregatedTasks />

      {isAgentOrThirdParty && (
        <div
          className={classNames(styles.btn, styles.selectionButton, {
            [styles.activeButton]: showSelection,
          })}
          onClick={() => onShowSelection(!showSelection)}
        >
          <MultiSelect />
        </div>
      )}
    </div>
  );
};
